import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import vars from '../lib/styled'
import { CardSubHeading } from './CardKitchen'
import { ButtonLink, ButtonLinkExternal } from './Button'

const CardWrapper = styled.article`
  margin: 1rem 0 0;
  padding: 1rem;
  position: relative;
  width: ${(props) => (props.small ? '33.33%' : '50%')};

  @media (max-width: ${vars.breakpoint.tablet}) {
    width: 100%;
  }
`

const CardBodyCSS = css`
  background: ${vars.contrast};
  box-shadow: ${vars.boxShadow};
  color: ${vars.secondary};
  display: block;
  font-size: 1em;
  padding: 4vh 2vw;
  position: relative;
  text-align: center;
  transition-duration: 250ms;
  transition-property: color, transform;

  &:hover {
    color: ${vars.accent};
  }
`

const CardDivider = styled.span`
  background-color: ${vars.accent};
  display: block;
  height: 50px;
  left: calc(50% - 1px);
  position: absolute;
  top: -25px;
  width: 2px;
  z-index: 1;
`

const CardBody = styled.div`
  ${CardBodyCSS};
`

const CardHeadingVariant = styled.h2`
  line-height: 1.1;
  margin-bottom: 1rem;
  margin-top: 0.25rem;

  @media (max-width: ${vars.breakpoint.tablet}) {
    font-size: 2.027em;
  }
`

const CardMediaLess = ({ title, subtitle, url, button, small }) => {
  let Btn
  let BodyProps

  if (url.startsWith('http')) {
    Btn = ButtonLinkExternal
    BodyProps = {
      href: url,
    }
  } else if (url.includes('@')) {
    Btn = ButtonLinkExternal
    BodyProps = {
      href: `mailTo:${url}`,
      target: false,
    }
  } else {
    Btn = ButtonLink
    BodyProps = {
      to: url,
    }
  }

  return (
    <CardWrapper small={small}>
      <CardDivider aria-hidden={true} />
      <CardBody>
        <CardSubHeading>{subtitle}</CardSubHeading>
        <CardHeadingVariant>{title}</CardHeadingVariant>
        <Btn {...BodyProps}>{button}</Btn>
      </CardBody>
    </CardWrapper>
  )
}

CardMediaLess.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  url: PropTypes.string,
  small: PropTypes.bool,
  button: PropTypes.string,
}

CardMediaLess.defaultProps = {
  url: '/',
  small: false,
  button: 'See All',
}

export default CardMediaLess
